import Icon from "hardcover-ui/components/Icon";
import { lazy, startTransition, Suspense, useRef, useState } from "react";
import chevronDown from "icons/solid/chevron-down.svg";
import { Drawer } from "features/Drawer";
import Button from "hardcover-ui/components/Button";
import OwnerReadingJournalOptions from "./OwnerReadingJournalOptions/OwnerReadingJournalOptions";
import plus from "icons/solid/plus.svg";
import { PageSerializersBooksLayout, ReadingJournalSerializersJournal } from "types/serializers";

const ReadingJournalModal = lazy(
  () =>
    import(
      "features/ReadingJournal/components/ReadingJournalModal/ReadingJournalModal"
    )
);

const OFFSET: [number, number] = [23, 10];

export default function OwnerReadingJournalControls({
  book,
  journals,
}: {
  book: PageSerializersBooksLayout;
  journals: ReadingJournalSerializersJournal[];
}) {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const openModal = () => {
    startTransition(() => {
      setEditOpen(true);
      setOpen(false);
    });
  };

  return (
    <div className="flex flex-row items-center space-x-2">
      <Button variant="tertiary" size="sm" onClick={openModal} ref={buttonRef}>
        <Icon icon={plus} />
        <span>New Entry</span>
      </Button>

      <Button
        variant="tertiary"
        size="sm"
        onClick={() => setOpen(true)}
        ref={buttonRef}
      >
        <span>Settings</span>
        <Icon icon={chevronDown} />
      </Button>

      {open && buttonRef.current ? (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                ref: buttonRef.current,
                isOpen: true,
                onClose: () => {},
                offset: OFFSET,
                placement: "bottom-end",
              }}
            />
          }
        >
          <Drawer
            settings={{
              ref: buttonRef.current,
              isOpen: true,
              onClose: () => setOpen(false),
              offset: OFFSET,
              placement: "bottom-end",
            }}
          >
            <OwnerReadingJournalOptions book={book} journals={journals} />
          </Drawer>
        </Suspense>
      ) : (
        false
      )}

      <Suspense>
        <ReadingJournalModal
          isOpen={editOpen}
          onClose={() => setEditOpen(false)}
          book={book}
        />
      </Suspense>
    </div>
  );
}
